export const LOG_TYPES = {
  ACCOUNT: "account",
  STATUS: "status",
};
export const options = (type, userID) => {
  const appDomain = `https://${window.location.hostname}`;
  const url = `${appDomain}/calendar?userId=${userID}&drawer=${type}`;
  return {
    URL: url,
    UserType: type,
    UserID: userID,
  };
};
